import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface LocationSuggestionItem {
  id: number;
  name: string;
  sublabel?: string;
}

export interface LocationSuggestionGroups {
  regions: LocationSuggestionItem[];
  subregions: LocationSuggestionItem[];
  propertyTypes: LocationSuggestionItem[];
  properties: LocationSuggestionItem[];
  mappings: LocationSuggestionItem[];
  keywordSuggestions: LocationSuggestionItem[];
  keyword: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class LocationLookupService {
  constructor(private httpClient: HttpClient) {}

  searchTerms(keywords: string): Observable<LocationSuggestionGroups> {
    if (!keywords || keywords.trim().length < 2) {
      return of({
        regions: [],
        subregions: [],
        propertyTypes: [],
        properties: [],
        mappings: [],
        keywordSuggestions: [],
        keyword: null,
      });
    }

    return this.httpClient
      .post<LocationSuggestionGroups>(
        `${environment.endpoints.api}/v1/search-terms`,
        {
          keywords,
        },
      )
      .pipe(
        map((terms) => ({
          regions: terms?.regions || [],
          subregions: terms?.subregions || [],
          propertyTypes: terms?.propertyTypes || [],
          properties: terms?.properties || [],
          mappings: terms?.mappings || [],
          keywordSuggestions: terms?.keywordSuggestions || [],
          keyword: terms?.keyword || keywords.trim(),
        })),
        catchError(() =>
          of({
            regions: [],
            subregions: [],
            propertyTypes: [],
            properties: [],
            mappings: [],
            keywordSuggestions: [],
            keyword: keywords.trim(),
          }),
        ),
      );
  }
}
